import type { RootState } from 'store'
import type { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'
import type { SettingState } from './types'

export const setting: Module<SettingState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
